<template>
  <b-row v-if="dashboard" class="px-3">
    <b-col class="pl-3" cols="12" md="8">
      <b-row class="p-0" v-if="jobs">
        <b-col v-for="{ entry } in jobs" :key="entry.id" cols="12" md="6" class="p-2">
          <job-card :job="entry" />
        </b-col>
        <b-col cols="12" class="px-2">
          <b-button
            class="float-right mt-3 px-4"
            variant="outline-primary"
            :to="{ name: 'JobIndex' }"
          >View All</b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col class="px-2 pt-2 pb-0" cols="12" md="4">
      <leaderboard v-if="leaderboard" :leaderboard="leaderboard" />
    </b-col>
  </b-row>
</template>

<script>
import JobCard from '@/components/dashboard/JobCard.vue';
import Leaderboard from '@/components/dashboard/Leaderboard.vue';
import ReferralRequest from '@/components/dashboard/ReferralRequest.vue';

export default {
  props: {
    dashboard: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    JobCard,
    Leaderboard,
    ReferralRequest,
  },
  // mounted() {
  //   console.log('JOBS: ', this.jobs);
  //   console.log('LEADERBOARD: ', this.leaderboard);
  // },
  // watch: {
  //   jobs() {
  //     console.log('JOBS1: ', this.jobs);
  //   },
  // },
  computed: {
    jobs() {
      const { dashboard: { jobConnections } } = this;
      return jobConnections && Array.isArray(jobConnections.edges) ? jobConnections.edges : null;
    },
    leaderboard() {
      const { dashboard: { leaderboards } } = this;
      return Array.isArray(leaderboards) && leaderboards[0] ? leaderboards[0] : null;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Introduce.vue